import { Pipe, PipeTransform } from '@angular/core';
import { Structure } from '@interfaces/Structure';

@Pipe({
  name: 'categoryHours'
})
export class CategoryHoursPipe implements PipeTransform {
  public transform(categoryId: string, classificationEstimadeId: string, structures: Structure[]): number {
    let total = 0;

    for (const structure of structures) {
      for (const estimateLine of structure.estimateLines) {
        if (estimateLine.categoryId === categoryId) {
          for (const classificationLine of estimateLine.classificationLines) {
            if (classificationLine.classificationEstimateId === classificationEstimadeId)
              total += classificationLine.hours;
          }
        }
      }
    }

    return total;
  }
}
